import React, { useState } from 'react'
import { useSendTransaction, Transaction } from '../../hooks'
import { MegaButton } from '../MegaButton'
import { Spinner } from '../Spinner'

interface Props {
  symbol: string
  transaction: Transaction | undefined
}

export function ApprovalButton({ symbol, transaction }: Props) {
  const sendTransaction = useSendTransaction()

  const [pending, setPending] = useState(false)

  async function sendApprove() {
    if (!transaction) {
      return
    }
    try {
      setPending(true)
      await sendTransaction(transaction)
    } catch (err) {
      setPending(false)
      if (err instanceof Error) {
        alert(err.message) // TODO: better error handling
      }
    }
  }

  return (
    <MegaButton disabled={pending} onClick={sendApprove}>
      Approve {symbol} {pending && <Spinner />}
    </MegaButton>
  )
}
